import ButtonLink from '@/common/components/ButtonLink'
import { cn } from '@/common/utils/cn'
import { RewardLedgerEntryData } from '@/features/tmaisUsers/types/rewardLedgerEntries.type'
import { CircleIcon } from 'lucide-react'
import { CardInfoCell } from './CardInfoCell'
import { CardWrapper } from './CardWrapper'

interface AcquiredTicketCardProps {
  entry: RewardLedgerEntryData
}

export const AcquiredTicketCard = ({ entry }: AcquiredTicketCardProps) => {
  const isNegative = parseFloat(entry.quantity_earned) < 0

  const getRaffleName = (entry: RewardLedgerEntryData): string => {
    if (entry.from && 'raffle' in entry.from) {
      return entry.from.raffle.display_name
    }
    return entry.reward?.display_name || '--'
  }

  return (
    <CardWrapper entry={entry}>
      <div className="grid grid-cols-2 gap-2">
        <CardInfoCell label="Sorteio">
          <ButtonLink
            linkTo={`/tmais-raffles/${entry.reward?.id}`}
            operationKlassToCheckPermission="Establishment::Tmais::Raffles::Show"
            hoverBackgroundSize="small"
          >
            <CircleIcon className="size-4 fill-slate-200 shrink-0" />

            <span className="text-sm truncate">{getRaffleName(entry)}</span>
          </ButtonLink>
        </CardInfoCell>

        <CardInfoCell label="Bilhetes">
          <img src="/TCoinTicket.svg" alt="TCoinTicket" className="size-4" />

          <span
            className={cn('text-sm', {
              'text-danger-soft': isNegative,
            })}
          >
            {Number(entry.quantity_earned ?? 0)}
          </span>
        </CardInfoCell>
      </div>
    </CardWrapper>
  )
}
